<template>
    <div style="flex: 1;">
<!--        <loading ref="loading" />-->

        <transition name="page" mode="out-in">
            <component :is="layout" v-if="layout" />
        </transition>
    </div>
</template>

<script>
// Load layout components dynamically.
import { mapActions } from 'pinia';
import { useAuthStore } from '@services/pinia/AuthStore';
import { useLayoutHandlerStore } from '@services/pinia/LayoutHandlerStore';

const requireContext = require.context('./Layout', false, /.*\.vue$/);

const layouts = requireContext.keys()
    .map((file) => [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)])
    .reduce((components, [name, component]) => {
        const arr = components;
        arr[name] = component.default || component;
        return arr;
    }, {});

export default {
    el: '#vueapp',

    components: {
        // Loading
    },

    data: () => ({
        layout: null,
        defaultLayout: 'FullLayout',
    }),

    created() {
        this.initLayout();
        this.getAuthUser();
    },

    methods: {
        ...mapActions(useAuthStore, ['getAuthUser']),
        ...mapActions(useLayoutHandlerStore, ['initLayout']),
        /**
         * Set the application layout.
         *
         * @param {String} layoutParam
         */
        setLayout(layoutParam) {
            let layout = layoutParam;
            if (!layout || !layouts[layout]) {
                layout = this.defaultLayout;
            }

            this.layout = layouts[layout];
        },
    },
};
</script>
